import { UserAvatar } from '@repo/atomic-components';
import { UserRoleLabels } from '@/api';
import { useOrganisationName } from '@/hooks';
import { selectUserAboutData, useAppSelector } from '@/store';

/** Read-only: name, role and organisation are set by an admin. */
export const AccountIdentityControl = () => {
  const userAboutData = useAppSelector(selectUserAboutData);
  const organisationName = useOrganisationName();

  const role = UserRoleLabels[userAboutData?.role as keyof typeof UserRoleLabels];

  return (
    <div className="border-theme-border-grey bg-theme-background-grey flex items-center gap-3 rounded-md border p-3">
      <UserAvatar name={userAboutData?.name} fontSize={14} aria-hidden />
      <div className="flex min-w-0 flex-col">
        <span className="text-theme-black truncate text-sm font-semibold">{userAboutData?.name}</span>
        <span className="text-theme-text-grey truncate text-sm">
          {[role, organisationName].filter(Boolean).join(' · ')}
        </span>
      </div>
    </div>
  );
};
